var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function(n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
__name(_extends, "_extends");
import React from "react";
import Icon from "@ant-design/icons";
var GoogleSvg = /* @__PURE__ */ __name(function GoogleSvg2() {
  return /* @__PURE__ */ React.createElement("svg", {
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "32",
    height: "32",
    viewBox: "0 0 32 32"
  }, /* @__PURE__ */ React.createElement("path", {
    d: "M16.004 14.063v4.203h5.988c-0.781 2.547-2.91 4.371-5.988 4.371-3.664 0-6.637-2.973-6.637-6.637s2.969-6.637 6.637-6.637c1.648 0 3.152 0.605 4.313 1.602l3.094-3.098c-1.953-1.781-4.555-2.867-7.406-2.867-6.078 0-11.004 4.926-11.004 11s4.926 11 11.004 11c9.234 0 11.273-8.637 10.367-12.922z"
  }));
}, "GoogleSvg");
var GoogleIcon = /* @__PURE__ */ __name(function GoogleIcon2(props) {
  return /* @__PURE__ */ React.createElement(Icon, _extends({
    component: GoogleSvg
  }, props));
}, "GoogleIcon");
export {
  GoogleIcon
};
